module.exports = __webpack_public_path__ + "static/media/storyIcon.7440d63a.png";